// extracted by mini-css-extract-plugin
module.exports = {"Container":"ChatPagesContainer_Container__a8Zzq","Client":"ChatPagesContainer_Client__o9Qw5","MainArea":"ChatPagesContainer_MainArea__mjOt5"};